import { render, staticRenderFns } from "./MlbPlayerTrends.vue?vue&type=template&id=a17be1ec&scoped=true"
import script from "./MlbPlayerTrends.vue?vue&type=script&lang=js"
export * from "./MlbPlayerTrends.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a17be1ec",
  null
  
)

export default component.exports